<template>
  <div class="container">
    <div class="row">
      <div class="form-group col-md-12">
        <label class="control-label">
          REMUNERACIÓN MENSUAL NETA DEL DECLARANTE, POR EL CARGO QUE OCUPA, ASÍ COMO
          EL INGRESO DEL CÓNYUGE, CONCUBINA O CONCUBINARIO Y/O DEPENDIENTES ECONÓMICOS
        </label>
  
        <br>
        <label for="" class="control-label">
          (Nota: Si sus ingresos percibidos son o fueron en el extranjero, las cifras se anotarán en pesos mexicanos, mencionando en el apartado para observaciones el tipo de moneda que corresponda y la fecha que se utilizó para el tipo de cambio)
          <br>
        </label>
        <label for="" class="control-label">Requisite cantidades libres de impuestos, <strong>SIN CENTAVOS Y SIN CEROS A LA IZQUIERDA.</strong></label>
        <!--  <p-radio class="d-inline-block" v-model="bandera" label="1">Si</p-radio>
        <p-radio class="d-inline-block" v-model="bandera" label="0">No</p-radio>-->
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-12">
        <p> I. Remuneración mensual neta del declarante por su cargo público (deduzca impuestos) (por concepto de sueldos, honorarios, compensaciones, bonos, aguinaldos y otras prestaciones)
        </p>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-12 align-self-end">
        <currency name="sub_1" v-validate="'required|min:1|numeric'" v-model="item_entes.sub_1" sign=""></currency>
        <small class="text-danger">{{ errors.first('remuneración anual')}}</small>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-12">
        <p>
          II. Otros ingresos mensuales netos del declarante (suma del II.1 al II.4)</p>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-12">
        <p>
          II. 1 Por actividad industrial y/o comercial
          Especifica nombre o razón social y tipo de negocio (Deduzca impuestos)
        </p>
      </div>
      <div class="form-group col-md-8">
        <input class="form-control" type="text" v-model="item_entes.razon_social" placeholder="Descripción">
        <small class="text-danger">{{ errors.first('actividad industrial y/o comercial')}}</small>
      </div>
      <div class="form-group col-md-4 align-self-end">
        <currency v-model="item_entes.razon_social_cantidad" sign=""></currency>
        <small class="text-danger">{{ errors.first('cantidad actividad industrial')}}</small>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-12">
        <p>
          II. 2 Por actividad financiera (rendimientos de contratos bancarios o de valores) (Deduzca impuestos)
        </p>
      </div>
      <div class="form-group col-md-8">
        <input class="form-control" type="text" v-model="item_entes.actividad_financiera" placeholder="Descripción">
        <small class="text-danger">{{ errors.first('actividad_financiera')}}</small>
      </div>
      <div class="form-group col-md-4 align-self-end">
        <currency v-model="item_entes.actividad_financiera_cantidad" sign=""></currency>
        <small class="text-danger">{{ errors.first('actividad_financiera_cantidad')}}</small>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-12">
        <p>II. 3 Por servicios profesionales, participación en consejos, consultorías o asesorías Especifica el tipo de servicio y el contratante (Deduzca impuestos)
        </p>
      </div>
      <div class="form-group col-md-8">
        <input class="form-control" type="text" v-model="item_entes.servicios_profecionales" placeholder="Descripción">
        <small class="text-danger">{{ errors.first('servicios_profecionales')}}</small>
      </div>
      <div class="form-group col-md-4 align-self-end">
        <currency v-model="item_entes.servicios_profecionales_cantidad" sign=""></currency>
        <small class="text-danger">{{ errors.first('servicios_profecionales_cantidad')}}</small>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-12">
        <p>II. 4 Otros (arrendamientos, regalías, sorteos, concursos, donaciones, etc.) Especifica (Deduzca impuestos)</p>
      </div>
      <div class="form-group col-md-8">
        <input class="form-control" type="text" v-model="item_entes.arrendamiento" placeholder="Descripción">
        <small class="text-danger">{{ errors.first('arrendamiento')}}</small>
      </div>
      <div class="form-group col-md-4 align-self-end">
        <currency v-model="item_entes.arrendamiento_cantidad" sign=""></currency>
        <small class="text-danger">{{ errors.first('arrendamiento_cantidad')}}</small>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-8 align-self-end" style="text-align: right;">
        SUBTOTAL
      </div>
      <div class="form-group col-md-4 align-self-end">
        <label></label>
        <currency v-model="calcula_totales1" sign="" readonly></currency>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-8 align-self-end" style="text-align: right;">
        Suma de subtotal y remuneración mensual
      </div>
      <div class="form-group col-md-4 align-self-end">
        <label> </label>
        <currency v-model="calcula_totales2" sign="" readonly></currency>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-8">
        <p>A. INGRESO MENSUAL NETO DEL DECLARANTE
        </p>
      </div>
      <div class="form-group col-md-12 align-self-end">
        <currency v-model="calcula_totales2" sign="" readonly></currency>
        <!-- <small class="text-danger">{{ errors.first('sub_11')}}</small> -->
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-12">
        <p>B. INGRESO MENSUAL NETO DEL CÓNYUGE CONCUBINA O CONCUBINARIO Y/O DEPENDIENTES ECONÓMICOS (DEDUZCA IMPUESTOS) ESPECIFICA
        </p>
      </div>
      <div class="form-group col-md-8">
        <input class="form-control" type="text" v-model="item_entes.neto_conyugue" placeholder="Descripción">
        <small class="text-danger">{{ errors.first('neto_conyugue')}}</small>
      </div>
      <div class="form-group col-md-4 align-self-end">
        <currency v-model="item_entes.neto_conyugue_cantidad" sign=""></currency>
        <small class="text-danger">{{ errors.first('neto_conyugue_cantidad')}}</small>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-8">
        <p>C. TOTAL DE INGRESO MENSUAL NETO DEL DECLARANTE, CÓNYUGE, CONCUBINA, CONCUBINARIO
          Y/O DEPENDIENTES ECONÓMICOS
        </p>
      </div>
      <div class="form-group col-md-4 align-self-end">
        <label for="">SUMA DE A Y B</label>
        <currency v-model="calcula_totales3" sign="" readonly></currency>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Tag,
    Select,
    DatePicker,
    InputNumber
  } from 'element-ui'

  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      [InputNumber.name]: InputNumber
    },
    props: ['data'],
    data() {
      return {
        numero: 0,
        ip_id: null,
        add_item: false,
        edit_item: null,
        modelValidations: {
          nombre: {
            min: 5
          },
          email: {
            required: true,
            email: true
          }
        },
        entes: null,
        //monedas: [],
        plazos: [],
        isnum: null,
        /* Lista de Bienes */
        item_entes: {
          sub_1: 0,
          sub_11: 0,
          razon_social_cantidad: 0,
          actividad_financiera_cantidad: 0,
          servicios_profecionales_cantidad: 0,
          arrendamiento_cantidad: 0,
          neto_conyugue_cantidad: 0,
          acciones: '',
          ente_publico_id: '',
          rfc_quien_adquirio: '',
          ingreso_bruto_anual: '',
          moneda_id: 97,
          unidad_temporal_id: '',
          duracion_frecuencia: '',
          fecha_transaccion: '',
          observaciones: '',
          bandera: '0'
        },
        fields_list: [{
            key: 'acciones',
            label: 'Acciones',
            tdClass: 'text-center'
          },
          {
            key: 'ente_publico_id',
            label: 'Ente Públic',
            tdClass: 'text-left',
            formatter: 'emptyFields'
          },
          {
            key: 'rfc',
            label: 'RFC',
            tdClass: 'text-left',
            formatter: 'emptyFields'
          },
          {
            key: 'ingreso_bruto_anual',
            label: 'Ingreso bruto anual ',
            tdClass: 'text-right',
            formatter: 'emptyFields'
          },
          {
            key: 'moneda_id',
            label: 'Moneda',
            tdClass: 'text-left',
            formatter: 'emptyFields'
          },
          {
            key: 'duracion_frecuencia',
            label: 'Duración / Frecuencia',
            tdClass: 'text-right',
            formatter: 'emptyFields'
          },
          {
            key: 'unidad_temporal_id',
            label: 'Unidad temporal',
            tdClass: 'text-left',
            formatter: 'emptyFields'
          },
          {
            key: 'fecha_transaccion',
            label: 'Fecha de transacción',
            tdClass: 'text-left',
            formatter: 'emptyFields'
          },
          {
            key: 'observaciones',
            label: 'Observaciones',
            tdClass: 'text-left',
            formatter: 'emptyFields'
          }
        ]
      }
    },
    computed: {
      getSigno() {
        var signo = '$'
        var val = this.item_entes.moneda_id
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            signo = item.signo
          }
        })
        return signo
      },
      calcula_totales1() {

        var sub1 = 0
        var sub2 = 0
        var unoydos = 0
        var segundasuma2 = 0

        var a = parseInt(this.item_entes.razon_social_cantidad);

        var b = parseInt(this.item_entes.actividad_financiera_cantidad);
        var c = parseInt(this.item_entes.servicios_profecionales_cantidad);
        var d = parseInt(this.item_entes.arrendamiento_cantidad);
        var e = parseInt(this.item_entes.arrendamiento_cantidad);

        sub1 = e;
        sub2 = a + b + c + d;
        unoydos = parseInt(sub1) + parseInt(sub2)
        // console.log(a, b, c, d, e, sub1, sub2, unoydos);


        /* if (sub2 > 1) {

        } else {
          sub2 = "Corrija las cantidades";
        }
        if (unoydos > 1) {

        } else {
          unoydos = "Corrija las cantidades";
        } */

        /* if (isNaN(sub2)) {
          return sub2
        } else {
          return 0
        } */

        // --this.item_entes.suma_1 = sub2
        //  --this.item_entes.suma_2 = unoydos
        //alert(sub2)
        /*  segundasuma2 = parseInt(this.item_entes.sub_1) + parseInt(this.item_entes.neto_conyugue_cantidad)

         if (segundasuma2 > 1) {

         } else {
           segundasuma2 = "Corrija las cantidades";
         } */

        //-- this.item_entes.suma_3 = segundasuma2

        if (isNaN(sub2)) {
          return 0
        }

        return sub2
      },
      calcula_totales2() {

        var sub1 = 0
        var sub2 = 0
        var unoydos = 0
        var segundasuma2 = 0

        sub1 = parseInt(this.item_entes.sub_1)
        sub2 = parseInt(this.item_entes.razon_social_cantidad) + parseInt(this.item_entes.actividad_financiera_cantidad) + parseInt(this.item_entes.servicios_profecionales_cantidad) + parseInt(this.item_entes.arrendamiento_cantidad)
        unoydos = parseInt(sub1) + parseInt(sub2)



        if (sub2 > 1) {

        } else {
          sub2 = "Corrija las cantidades";
        }
        if (unoydos > 1) {

        } else {
          unoydos = "Corrija las cantidades";
        }

        if (isNaN(unoydos)) {
          return 0
        }
        //this.item_entes.sub_11 = unoydos;
        return unoydos
        // --this.item_entes.suma_1 = sub2
        //  --this.item_entes.suma_2 = unoydos
        //alert(sub2)
        /* segundasuma2 = parseInt(this.item_entes.sub_1) + parseInt(this.item_entes.neto_conyugue_cantidad)

        if (segundasuma2 > 1) {

        } else {
          segundasuma2 = "Corrija las cantidades";
        } */

        //-- this.item_entes.suma_3 = segundasuma2

      },
      calcula_totales3() {

        /* var sub1 = 0
        var sub2 = 0
        var unoydos = 0
        var segundasuma2 = 0

        sub1 = parseInt(this.item_entes.sub_1)
        sub2 = parseInt(this.item_entes.razon_social_cantidad) + parseInt(this.item_entes.actividad_financiera_cantidad) + parseInt(this.item_entes.servicios_profecionales_cantidad) + parseInt(this.item_entes.arrendamiento_cantidad)
        unoydos = parseInt(sub1) + parseInt(sub2)



        if (sub2 > 1) {

        } else {
          sub2 = "Corrija las cantidades";
        }
        if (unoydos > 1) {

        } else {
          unoydos = "Corrija las cantidades";
        }
 */
        //return unoydos
        // --this.item_entes.suma_1 = sub2
        //  --this.item_entes.suma_2 = unoydos
        //alert(sub2)
        var segundasuma2 = 0
        segundasuma2 = parseInt(this.calcula_totales2) + parseInt(this.item_entes.neto_conyugue_cantidad)

        if (isNaN(segundasuma2)) {
          return 0
        }
        return segundasuma2;

        /* if (segundasuma2 > 1) {

        } else {
          segundasuma2 = "Corrija las cantidades";
        } */

        //-- this.item_entes.suma_3 = segundasuma2

      },

      getCodigoMoneda() {
        var codigo = 'MXN'
        var val = this.item_entes.moneda_id
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            codigo = item.codigo
          }
        })
        return codigo
      }
    },
    watch: {


    },
    methods: {
      getSignoDos(val = '97') {
        var signo = '$'
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            signo = item.signo
          }
        })
        return signo
      },
      emptyFields(value) {
        if (value) {
          if (typeof value === 'string' || value instanceof String) {
            return value.toUpperCase()
          } else {
            return value
          }
        } else {
          return '-'
        }
      },
      getEnte(index) {
        var resp = ' '
        if (this.entes) {
          this.entes.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor
              return resp
            }
          })
        }
        return resp
      },
      getMoneda(index) {
        var resp = ''
        if (this.monedas) {
          this.monedas.forEach(function (item) {
            if (item.id == index) {
              resp = item.moneda
            }
          })
        }
        return resp
      },
      getUnidades(index) {
        var resp = ' '
        if (this.plazos) {
          this.plazos.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor
              return resp
            }
          })
        }
        return resp
      },


      addItem() {
        console.log(1111);
        if (this.item_entes) {
          this.item_entes.ip_id = this.ip_id
          this.loadButton(this.$refs.btnSave)
          this.$http.post('sueldos_publicos', this.item_entes).then(
            response => {
              this.StepOk('Guardado')
              // this.item_entes = response.data.sueldos
              // if (this.edit_item === undefined || this.edit_item === null) {
              this.item_entes = response.data.sueldos
              // }
              // this.showItem()
              // this.initItem()
              //  this.edit_item = null
            },
            error => {
              this.StepError(error)
              // this.change =  true;
            }
          )
        } else {
          this.StepW('Hay campos sin completar')
        }
        // console.log(this.item_entes);
      },
      valida() {
        return this.$validator.validateAll()
      },
    },
    created() {
      //this.initItem()
      this.ip_id = this.getId();

      // this.getLocalidades(97250);
      this.$http.get('sueldos_publicos/' + this.ip_id).then(
        response => {
          // this.list_entes = response.data.sueldos
          if (response.data.sueldos != null) {
            this.item_entes = response.data.sueldos
          }

        },
        error => {
          this.Err(error)
        }
      )
      this.$http.get('cat_ente_publico').then(
        response => {
          this.entes = response.data.entes_publicos
        },
        error => {
          this.Err(error)
        }
      )
      this.$http.get('cat_unidad_medida_plazo').then(
        response => {
          this.plazos = response.data.unidades
        },
        error => {
          this.Err(error)
        }
      )
      /*this.$http.get('monedas').then(
        response => {
          this.monedas = response.data.monedas
          var temp = '97'
          this.monedas.forEach(function (item) {
            if (item.codigo == 'MXN') {
              temp = item.id
            }
          })
          this.item_entes.moneda_id = temp
        },
        error => {
          this.Err(error)
        }
      )*/
    }
  }

</script>
<style>


</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Ingresos/SueldosSalarios.vue